import { useTranslation } from '@hooks/useTranslation';
import { Box, Typography, Radio, RadioGroup, FormControlLabel, FormControl, Divider } from '@mui/material';
import { useState } from 'react';
import WolfButton from '@components/ui/WolfButton';
import { ConsentOption } from '@models/user.model';

interface LogRocketConsentModalProps {
  onConsent: (option: ConsentOption) => void;
  initialValue?: ConsentOption;
}

const LogRocketConsentModal: React.FC<LogRocketConsentModalProps> = ({ onConsent, initialValue = 'identified' }) => {
  const localeLogRocket = useTranslation('logRocket');
  const localeCommon = useTranslation('common');
  const [selectedOption, setSelectedOption] = useState<ConsentOption>(initialValue);

  const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedOption(event.target.value as ConsentOption);
  };

  const handleSubmit = () => {
    onConsent(selectedOption);
  };

  return (
    <Box className="flex flex-col gap-4">
      <Typography variant="body16">{localeLogRocket['description']}</Typography>
      <Typography variant="body16">{localeLogRocket['description2']}</Typography>

      <FormControl component="fieldset">
        <RadioGroup value={selectedOption} onChange={handleOptionChange}>
          <FormControlLabel
            value="identified"
            control={<Radio />}
            label={
              <Box>
                <Typography variant="body16">{localeLogRocket['accept']}</Typography>
              </Box>
            }
          />
          <FormControlLabel
            value="decline"
            control={<Radio />}
            label={
              <Box>
                <Typography variant="body16">{localeLogRocket['decline']}</Typography>
              </Box>
            }
          />
        </RadioGroup>
      </FormControl>

      <Divider />
      <Box className="flex justify-end">
        <WolfButton onClick={handleSubmit} variant="contained" color="primary" autoFocus>
          {localeCommon['confirm']}
        </WolfButton>
      </Box>
    </Box>
  );
};

export default LogRocketConsentModal;
